<template>
  <div class="box_background">
    <div class="vertical_level">
      <div class="vertical_level_size">
        <img src="./images/logo002.png" alt />
      </div>
      <div class="login-wrap">
        <div class="Icons_selection_boxes Icons_selection_item">
          <img src="./images/user.png" alt class="icon_flev" />
          <input type="text" class="a1" v-model="loginForm.uc" placeholder="请输入用户名" maxlength="15"
            @keyup.enter="login()" />
        </div>
        <div class="Icons_selection_boxes_two Icons_selection_item">
          <img src="./images/possword.png" alt class="icon_flev" />
          <input type="password" class="a1" v-model="loginForm.pwd" placeholder="请输入密码" maxlength="15"
            @keyup.enter="login()" />
        </div>
        <div class="sign_in" @click="login">
          <button class="login_btn">登录</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getPublicKey,ssoLogin } from "../../http/login";
  import { getUrlKey } from '../../components/Common/utils.js'    //获取url参数
  export default {
    data() {
      return {
        webTimePaw: '',
        loginForm: {
          uc: "",
          pwd: "",
          vdnId: "",
        },
        isShowKaptcha: false,
      };
    },
    methods: {
      // 写点击事件的方法
      async login() {
        // 判断用户名和密码是否为空
        if (this.loginForm.uc === "") {
          this.$Msg.error("账号不能为空");
        } else if (this.loginForm.pwd === "") {
          this.$Msg.error("密码不能为空");
        } else if (this.loginForm.vdnId == '') {
          this.$Msg.error("vdnId不能为空");
        } else {
          const res = await this.loginBefore();
          if (res.retCode == 1) {
            if (res.data.publicKey && res.data.time) {
              this.isgetUrlKey = true;//如果有密匙才加密
              this.webTimePaw = res.data.time - parseInt(new Date().getTime() / 1000);
            }
          }

          let time_s = parseInt(new Date().getTime() / 1000) + this.webTimePaw;
          let obj = {
            uc: this.loginForm.uc,
            pwd: this.$encryptedData(res.data.publicKey, this.loginForm.pwd + '|' + time_s),
            vdnId: this.loginForm.vdnId,
          }
          ssoLogin(obj).then(res => {
            console.log(res);
            if (res && res.retCode == 100) {
              this.$Msg.success(res.retMsg);
              setTimeout(() => {
                location.href = res.data
              },1000)
            }
          });
        }
      },

      loginBefore() {
        return new Promise((resolve, reject) => {
          let data = {
            vdnId: this.loginForm.vdnId
          }
          getPublicKey(data).then(res => {
            resolve(res)
          })
        })

      }
    },
    created() {
      this.loginForm.vdnId = getUrlKey('vdnId')
    },
    mounted() {
    },

  };
</script>


<style scoped>
  .box_background {
    width: 100%;
    height: 100%;
    background: url("./images/login_bg002.jpg");
    background-size: cover;
  }
  input:-webkit-autofill {
    transition: background-color 5000s ease-in-out 0s;
  }
  input{
    -webkit-text-fill-color:#fff;
  }
  .vertical_level {
    width: 350px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .a1 {
    margin-left: 12px;
    border-width: 0;
    width: 82%;
    height: 100%;
    outline: none;
    background: #105AA5;
    color: #fff;
  }

  .login-wrap {
    background: rgb(47 156 217 / 60%);
    padding: 40px;
    box-shadow: 0px 0px 8px #0b8d95;
  }

  .a2 {
    margin-left: 12px;
    border-width: 0;
    width: 50%;
    height: 100%;
    outline: none;
    background: #fff !important;
    color: #353A42;
  }

  .i1 {
    width: 80px;
    height: 33px;
    background: red;
  }

  .vertical_level_size {
    margin: 20px auto;
    margin-top: 0;
  }

  .vertical_level_size img {
    width: 100%;
    height: 100%;
  }

  .Icons_selection_boxes {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Icons_selection_boxes_two {
    margin: 20px auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Icons_selection_item input::-webkit-input-placeholder {
    color: #fff;
  }

  .Icons_selection_item {
    border: 1px solid #105AA5;
    border-radius: 4px;
    background: #105AA5;
    width: 100%;
    height: 35px;
    line-height: 35px;
    box-sizing: border-box;
  }

  .sign_in {
    border-radius: 4px;
    background: #fff;
    width: 100%;
    height: 35px;
    margin: 25px auto 0;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .login_btn {
    background: transparent;
    border-width: 0;
    outline: none;
    font-size: 18px;
    color: #105AA5;
    display: inline-block;
    width: 100%;
    cursor: pointer;
  }

  .sign_in:hover {
    background: #ddd;
  }

  .icon_flev {
    width: 23px;
    height: 23px;
  }
</style>


// WEBPACK FOOTER //
// ssoLogin.vue?56b7880e